import { IFlightPublicStatus } from '../domain/models/IFlightPublicStatus';

export function getTranslationKeyForStatus(status: IFlightPublicStatus) {
	switch (status) {
		case 'Arrived':
			return 'flight_status_arrived';

		case 'Arriving':
			return 'flight_status_arriving';

		case 'Boarding':
			return 'flight_status_boarding';

		case 'Cancelled':
			return 'flight_status_canceled';

		case 'Canceled':
			return 'flight_status_canceled';

		case 'Closed':
			return 'flight_status_gate_closed';

		case 'Departed':
			return 'flight_status_departed';

		case 'Delayed':
			return 'flight_status_delayed';

		case 'Landed':
			return 'flight_status_landed';

		case 'On Time':
			return 'flight_status_on_time';

		default:
			return undefined;
	}
}
